module.exports = __webpack_public_path__ + "static/media/micro-set.f68df671.png";